// Map registry. Single source of truth for every playable map. Add new
// maps to this list AND export them by name; the lobby (v0.7) will read
// MAPS to populate the map-picker UI. For now there's no picker —
// GameStore boots with `ringMap` (the smallest, most-balanced layout).

import type { MapDefinition } from './schema.js';
import { ringMap } from './ring.js';
import { slashMap } from './slash.js';
import { terraMap } from './terra.js';

export { ringMap } from './ring.js';
export { slashMap } from './slash.js';
export { terraMap } from './terra.js';

/**
 * Default map at boot. Used by GameStore until the lobby ships.
 */
export const DEFAULT_MAP: MapDefinition = ringMap;

/**
 * Every shipped map. Order matters for UI rendering — small / familiar
 * first, larger / experimental later.
 */
export const MAPS: readonly MapDefinition[] = [ringMap, slashMap, terraMap];

/**
 * Lookup-by-id form of MAPS, for code that has a map id string (e.g.
 * the multiplayer API loading state from Postgres) and needs the full
 * definition. Built from MAPS so adding a new map automatically
 * registers it here too.
 */
export const mapsById: Readonly<Record<string, MapDefinition>> =
  Object.fromEntries(MAPS.map((m) => [m.id, m]));
